export class User {
  login_id: string;
  name: string;
  role: string;
  school_id: string;
  password: string;
  touan_upload_auth: boolean = false;
  scoring_auth: boolean = false;
}

export class Curriculum {
  id: number
  name: string
  is_selected: boolean

  constructor(curriculum: any, is_selected: boolean){
    this.id = curriculum.id;
    this.name = curriculum.name;
    this.is_selected = is_selected;
  }
}